import { tsValidateString, tsValidateUniqueId, tsValidateValue } from '@nu-art/ts-common';
import { smartDocStaticParamType_Template } from './types.js';
import { Validator_SmartDocStaticParamType } from '../_base/index.js';
import { Validator_SmartDocParmaResolver_TemplateResolver } from '../../../smart-doc-param-resolver/index.js';
export const Validator_SmartDocStaticParam_Template = {
    key: tsValidateString(),
    type: Validator_SmartDocStaticParamType,
    subType: tsValidateValue([smartDocStaticParamType_Template]),
    resolver: Validator_SmartDocParmaResolver_TemplateResolver,
    id: tsValidateUniqueId,
};
//# sourceMappingURL=validator.js.map